import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  server: {
    NODE_ENV: z
      .enum(["development", "test", "production"])
      .default("development"),
    CRON_SECRET:
      process.env.NODE_ENV === "production"
        ? z.string().min(1)
        : z.string().min(1).optional(),
    POSTGRES_URL: z.url(),
    WORKOS_CLIENT_ID: z.string(),
    WORKOS_API_KEY: z.string(),
    WORKOS_COOKIE_PASSWORD: z.string(),
    AWS_REGION: z.string().optional(),
    AWS_ACCESS_KEY_ID: z.string(),
    AWS_SECRET_ACCESS_KEY: z.string(),
    CONTENT_MEDIA_IMAGE_S3_BUCKET: z.string(),
    CONTENT_MEDIA_VIDEO_S3_BUCKET: z.string(),
    GOOGLE_SERVICE_ACCOUNT_EMAIL: z.string(),
    GOOGLE_PRIVATE_KEY: z.string(),
    META_APP_ID: z.string().optional(),
    META_APP_SECRET: z.string().optional(),
    META_PARTNER_BUSINESS_ID: z.string().optional(),
    META_PARTNER_SYSTEM_USER_ACCESS_TOKEN: z.string().optional(),
    META_LOGIN_CONFIG_ID: z.string().optional(),
    META_TOKEN_KMS_KEY_ID: z.string().optional(),
    META_OAUTH_STATE_SECRET: z.string().optional(),
    META_GRAPH_API_VERSION: z.string().default("v24.0"),
    META_CAPI_ACCESS_TOKEN: z.string().min(1),
    MUX_TOKEN_ID: z.string().optional(),
    MUX_TOKEN_SECRET: z.string().optional(),
    MUX_VIDEO_QUALITY: z.enum(["basic", "plus", "premium"]).default("basic"),
    MUX_WEBHOOK_SECRET: z.string().optional(),
    GOOGLE_GENERATIVE_AI_API_KEY: z.string().min(1),
    CONTENT_ELIGIBILITY_ANALYSIS_MODEL: z.string().default("gemini-3.8-flash"),
    PYTHON_API_ENDPOINT: z.url().optional(),
    PYTHON_API_KEY: z.string().min(1).optional(),
    KV_REST_API_URL: z.url().optional(),
    KV_REST_API_TOKEN: z.string().min(1).optional(),
  },
  client: {
    NEXT_PUBLIC_WORKOS_REDIRECT_URI: z.url(),
    NEXT_PUBLIC_POSTHOG_KEY: z.string(),
    NEXT_PUBLIC_CONTENT_MEDIA_IMAGE_BASE_URL: z.url(),
    NEXT_PUBLIC_META_PIXEL_ID: z.string().default("2525838267862255"),
  },
  runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    CRON_SECRET: process.env.CRON_SECRET,
    POSTGRES_URL: process.env.POSTGRES_URL,
    WORKOS_CLIENT_ID: process.env.WORKOS_CLIENT_ID,
    WORKOS_API_KEY: process.env.WORKOS_API_KEY,
    WORKOS_COOKIE_PASSWORD: process.env.WORKOS_COOKIE_PASSWORD,
    AWS_REGION: process.env.AWS_REGION,
    AWS_ACCESS_KEY_ID: process.env.AWS_ACCESS_KEY_ID,
    AWS_SECRET_ACCESS_KEY: process.env.AWS_SECRET_ACCESS_KEY,
    NEXT_PUBLIC_CONTENT_MEDIA_IMAGE_BASE_URL:
      process.env.NEXT_PUBLIC_CONTENT_MEDIA_IMAGE_BASE_URL,
    CONTENT_MEDIA_IMAGE_S3_BUCKET: process.env.CONTENT_MEDIA_IMAGE_S3_BUCKET,
    CONTENT_MEDIA_VIDEO_S3_BUCKET: process.env.CONTENT_MEDIA_VIDEO_S3_BUCKET,
    GOOGLE_SERVICE_ACCOUNT_EMAIL: process.env.GOOGLE_SERVICE_ACCOUNT_EMAIL,
    GOOGLE_PRIVATE_KEY: process.env.GOOGLE_PRIVATE_KEY,
    META_APP_ID: process.env.META_APP_ID,
    META_APP_SECRET: process.env.META_APP_SECRET,
    META_PARTNER_BUSINESS_ID: process.env.META_PARTNER_BUSINESS_ID,
    META_PARTNER_SYSTEM_USER_ACCESS_TOKEN:
      process.env.META_PARTNER_SYSTEM_USER_ACCESS_TOKEN,
    META_LOGIN_CONFIG_ID: process.env.META_LOGIN_CONFIG_ID,
    META_TOKEN_KMS_KEY_ID: process.env.META_TOKEN_KMS_KEY_ID,
    META_OAUTH_STATE_SECRET: process.env.META_OAUTH_STATE_SECRET,
    META_GRAPH_API_VERSION: process.env.META_GRAPH_API_VERSION,
    META_CAPI_ACCESS_TOKEN: process.env.META_CAPI_ACCESS_TOKEN,
    MUX_TOKEN_ID: process.env.MUX_TOKEN_ID,
    MUX_TOKEN_SECRET: process.env.MUX_TOKEN_SECRET,
    MUX_VIDEO_QUALITY: process.env.MUX_VIDEO_QUALITY,
    MUX_WEBHOOK_SECRET: process.env.MUX_WEBHOOK_SECRET,
    GOOGLE_GENERATIVE_AI_API_KEY: process.env.GOOGLE_GENERATIVE_AI_API_KEY,
    CONTENT_ELIGIBILITY_ANALYSIS_MODEL:
      process.env.CONTENT_ELIGIBILITY_ANALYSIS_MODEL,
    PYTHON_API_ENDPOINT: process.env.PYTHON_API_ENDPOINT,
    PYTHON_API_KEY: process.env.PYTHON_API_KEY,
    KV_REST_API_URL: process.env.KV_REST_API_URL,
    KV_REST_API_TOKEN: process.env.KV_REST_API_TOKEN,
    NEXT_PUBLIC_WORKOS_REDIRECT_URI:
      process.env.NEXT_PUBLIC_WORKOS_REDIRECT_URI,
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY,
    NEXT_PUBLIC_META_PIXEL_ID: process.env.NEXT_PUBLIC_META_PIXEL_ID,
  },
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
  emptyStringAsUndefined: true,
});
